import type { CategoryWithSelectedProduct } from "../models";

export const calculateTotal = (
  selectedCategories: CategoryWithSelectedProduct[],
) => {
  return selectedCategories.reduce((acc, category) => {
    const selectedProductPrice = category.selectedProduct?.selectedPrice;

    if (!selectedProductPrice) {
      return acc;
    }

    const price = selectedProductPrice.price;

    return acc + price;
  }, 0);
};

export const calculateDiscountedTotal = (
  selectedCategories: CategoryWithSelectedProduct[],
) => {
  return selectedCategories.reduce((acc, category) => {
    const selectedProductPrice = category.selectedProduct?.selectedPrice;

    if (!selectedProductPrice) {
      return acc;
    }

    const price = selectedProductPrice.discount?.isValid
      ? selectedProductPrice.discount.priceAfterDiscount
      : selectedProductPrice.price;

    return acc + price;
  }, 0);
};
